import { T } from 'gt-react';
import {
  WorkbookAutomationSections,
  type AutomationsSectionProps,
} from './workbookIntegrations';

/** The Automations tab: one section per integration declaring the `automations` surface. */
export function WorkbookAutomations(props: AutomationsSectionProps) {
  return (
    <div className="max-w-3xl space-y-3">
      <h2 className="font-medium">
        <T context="workbook automations heading">Automations</T>
      </h2>
      <WorkbookAutomationSections {...props} />
    </div>
  );
}
